<template>
  <span class="status fixed-width" :class="`mktp_status_id_` + mktpRentStatus.mktp_status_id" style="margin: -5px 0;">
    <div class="text">{{ mktpRentStatus.status.name }}</div>
    <div class="time">{{ mktpRentStatus.created_at | time }}</div>
  </span>
</template>

<script>
  export default{
    name: 'MktpRentStatus',
    props: ['mktpRentStatus', 'classes'],
    components: {},
    data () {
      return {}
    },
    mounted () {},
    methods: {
      getClasses () {
        return this.classes || ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// MktpRentStatus.vue?b0b90764